module.exports = __webpack_public_path__ + "img/logofull.25acb804.svg";